import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'

import CardSelectionPrototype from './prototype/CardSelection'
import type { CardSelectionItem } from './prototype/CardSelection/types'

type ResolvedLink = {
	label: string
	url: string
	isExternal: boolean
}

type Card = {
	image?: { src: string; alt?: string }
	category?: string
	title?: string
	href: string
	isExternal: boolean
}

type CardSelectionPartData = {
	overline?: string
	title?: string
	intro?: string
	cta?: ResolvedLink
	cards?: Card[]
}

// The processor gives each card a resolved `href` plus the `isExternal` flag `resolveLink`
// returned for it, while the prototype item takes `url`/`isExternal`. `alt` and `category` are
// required strings on the prototype item, so both fall back to an empty string rather than being
// left undefined.
function toItem(card: Card): CardSelectionItem {
	return {
		image: card.image ? { src: card.image.src, alt: card.image.alt || card.title || '' } : undefined,
		category: card.category || '',
		title: card.title,
		url: card.href,
		isExternal: !!card.isExternal,
	}
}

export const CardSelection = ({ data }: ComponentProps<PartData>) => {
	const { overline, title, intro, cta, cards = [] } = (data || {}) as CardSelectionPartData

	return (
		<CardSelectionPrototype
			overline={overline}
			title={title}
			intro={intro}
			cta={cta}
			cards={cards.map(toItem)}
		/>
	)
}
